<template>
  <div class="addOthers">
    <div class="header">
      <div @click="onCancel">取消</div>
      <div>添加外部参会人</div>
      <div class="confirm" @click="onConfirm">确认</div>
    </div>
    <div class="content">
      <p class="part_title">外部参会人（{{ outersList.length }}人）</p>
      <div v-for="(item, index) in outersList" :key="index" class="cell">
        <van-cell>
          <div slot="title">
            <div class="van-cell-text">
              <div class="first">
                <div class="imgArea">
                  <svg-icon icon-class="staff_avatar" class="img" />
                </div>
                <div class="info">
                  <div class="name">{{ item.attendee }}/{{ item.phone }}</div>
                  <div class="company">{{ item.company }}</div>
                </div>
              </div>
            </div>
          </div>
          <div slot="right-icon" class="last" @click="() => onDelete(index)">
            <div class="imgArea" @click="onDelete">
              <svg-icon icon-class="delete" class="img" style="width: 1.2em; height: 1.2em" />
            </div>
          </div>
        </van-cell>
      </div>
    </div>
    <div class="footer">
      <van-cell-group>
        <van-field v-model.trim="dataForm.attendee" required label="姓名" placeholder="请输入姓名" />
        <van-field v-model.trim="dataForm.phone" required type="number" label="手机号" placeholder="请输入手机号" />
        <van-field v-model.trim="dataForm.company" label="公司名称" placeholder="请输入公司名称" />
      </van-cell-group>
    </div>
    <div class="btn">
      <van-button type="info" size="large" @click="onAdd">添加参会人</van-button>
    </div>
  </div>
</template>

<script>
import { Form, Notify } from 'vant';
import { searchStaff } from '@/api/home';
export default {
  name: 'AddOthers',
  components: {
    [Form.name]: Form,
    [Notify.name]: Notify
  },
  data() {
    return {
      value: '',
      outersList: [],
      dataForm: {
        attendee: '',
        phone: '',
        company: ''
      }
    };
  },
  computed: {
    outers() {
      this.outersList = this.$store.state.outersIds;
      return this.$store.state.outersIds;
    }
  },
  watch: {
    outers() {},
    outersList(val) {
      this.$store.dispatch('setOutersIds', { list: val });
    }
  },
  methods: {
    onConfirm() {
      this.$router.go(-1);
      this.$store.dispatch('setOuters', { list: this.outersList });
    },
    onCancel() {
      this.$router.go(-1);
    },
    onDelete(idx) {
      this.outersList = this.outersList.filter((item, index) => {
        return index !== idx;
      });
    },
    onAdd() {
      if (!this.dataForm.attendee || !this.dataForm.phone) {
        Notify({ type: 'warning', message: '请填写完整' });
      } else if (this.checkPhone(this.dataForm.phone)) {
        this.searchStaff(this.dataForm.phone);
      } else {
        Notify({ type: 'warning', message: '手机号格式错误，请检查' });
      }
    },
    checkPhone(phone) {
      if (phone === '') {
        phone = false;
        this.phonErrMsg = '请输入手机号';
      } else if (!/^1[3456789]\d{9}$/.test(phone)) {
        this.phonErrMsg = '手机号格式错误，请检查';
        phone = false;
      } else {
        this.phonErrMsg = '';
        phone = true;
      }
      return phone;
    },
    searchStaff(phone) {
      searchStaff({ phone }).then(res => {
        if (res.data) {
          const data = {
            attendee: res.data.name,
            phone: res.data.phone,
            company: res.data.company
          };
          this.outersList.push(data);
          this.dataForm = {
            attendee: '',
            phone: '',
            company: ''
          };
        } else {
          this.outersList.push(this.dataForm);
          this.dataForm = {
            attendee: '',
            phone: '',
            company: ''
          };
        }
      });
    }
  }
};
</script>

<style lang="less" scoped>
 .addOthers {
   .header {
     height: 0.44rem;
     font-size: 0.17rem;
     font-weight: 400;
     line-height: 0.24rem;
     color: #333333;
     background: #FFFFFF;
     display: flex;
     justify-content: space-between;
     align-items: center;
     padding: 0 0.135rem;
     .confirm {
       color: #3B86FF;
     }
   }
   .content {
     .part_title {
       color: #888;
       font-size: 0.14rem;
       margin-left: 0.15rem;
       line-height: 0.45rem;
     }
     .cell {
       .first {
         display: flex;
         .imgArea {
           display: flex;
           align-items: center;
           .img {
             width: 0.355rem;
             height: 0.355rem;
           }
         }
         .info {
           display: flex;
           flex-direction: column;
           margin-left: 0.12rem;
         }
         .name {
           font-size: 0.17rem;
           font-weight: 400;
           line-height: 0.24rem;
           color: #001833;
         }
         .company {
           font-size: 0.14rem;
           font-family: PingFang SC;
           font-weight: 400;
           line-height: 0.2rem;
           color: rgba(51, 51, 51, 0.7);
         }
       }
       .last {
         display: flex;
         .imgArea {
           display: flex;
           align-items: center;
           .img {
             width: 0.15rem;
             height: 0.15rem;
           }
         }
       }
     }
   }
   .footer {
     margin: 0.15rem;
     background: #FFFFFF;
     border: 1px solid #EFEFF4;
     box-shadow: 0px 3px 6px rgba(51, 51, 51, 0.1);
     opacity: 1;
     border-radius: 6px;

   }
   .btn {
     margin: 0.15rem;
   }
 }
</style>
